import React from 'react';

export const ArrowDownIcon = () => (
  <svg
    className="arrow-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <polyline points="19 12 12 19 5 12"></polyline>
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/ArrowDown.icon.jsx